"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMediaObject = void 0;
var _MediaObject = require("./MediaObject");
// TODO: in v9, move styled() from MediaObject.jsx to here
var StyledMediaObject = _MediaObject.MediaObject;
exports.StyledMediaObject = StyledMediaObject;